import React from 'react'
import PropTypes from 'prop-types'

import css from './styles.css'

export default function RadioButton(props) {
  const {
    appointmentType,
    appointmentType: { post_nv_window: window },
    updatedAppointmentVisibility,
    preventDefaultUpdate,
  } = props

  return (
    <div
      role="radio"
      aria-checked="false"
      tabIndex="0"
      className={css.radioButtonGroup}
      onClick={() =>
        preventDefaultUpdate(
          updatedAppointmentVisibility,
          appointmentType,
          window,
        )
      }
    >
      <span
        className={
          updatedAppointmentVisibility === appointmentType.visibility
            ? css.radioButtonActive
            : css.radioButton
        }
      />
    </div>
  )
}

RadioButton.propTypes = {
  appointmentType: PropTypes.shape({
    visibility: PropTypes.string,
  }),
  updatedAppointmentVisibility: PropTypes.string.isRequired,
  preventDefaultUpdate: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/AppointmentTypes/RadioButton.js